<template>
  <div id="app">
    <div
      class="main-wrapper"
      :class="{ 'is-blurred': leftMenuVisible }"
    >
      <div
        class="veil"
        v-show="veil_visible"
      ></div>
      <app-header v-if="$route.path !== '/login'"></app-header>
      <app-left-menu></app-left-menu>
      <app-mob-menu></app-mob-menu>
      <main :class="{ 'login': $route.path === '/login' }">
        <app-top v-if="$route.path != '/login'"></app-top>
        <router-view v-if="user || $route.path === '/login'"></router-view>
      </main>
      <app-share-tickets></app-share-tickets>
      <app-view-qr></app-view-qr>
      <app-view-qr-card></app-view-qr-card>
      <app-support></app-support>
      <app-change-name></app-change-name>
      <next-lvl-requirements></next-lvl-requirements>
      <next-lvl-achieved></next-lvl-achieved>
      <fill-profile></fill-profile>
      <badge-dets></badge-dets>
      <points-received></points-received>
      <mx-preloader v-if="isShowMXPreloader"></mx-preloader>
      <!-- <test-mark></test-mark> -->
    </div>
  </div>
</template>

<script>
  import Header from './components/header.vue'
  import TopSection from './components/top-section.vue'
  import SharePopup from './components/pop-ups/share-tickets.vue'
  import QrPopup from './components/pop-ups/qr-code.vue'
  import QrCardPopup from './components/pop-ups/card-numer-qr-code'
  import SupportPopup from './components/pop-ups/support.vue'
  import ChangeName from './components/pop-ups/change-name.vue'
  import LeftMenu from './components/pop-ups/left-menu.vue'
  import MobMenu from './components/pop-ups/mob-menu.vue'
  import NextLvlRequirements from './components/pop-ups/next-lvl-reqirements.vue'
  import NextLvlAchieved from './components/pop-ups/next-lvl-achieved.vue'
  import FillProfile from './components/pop-ups/fill-profile.vue'
  import BadgeDets from './components/pop-ups/badge-dets.vue'
  import PointsReceived from './components/pop-ups/points-received.vue'
  import TestMark from './components/pop-ups/test-mark.vue'
  import MXPreloader from './components/entities/preloader/index.vue'
  import Store from './store'

  export default {
    name: 'app',
    computed: {
      veil_visible: function () {
        return Store.state.veil_visible
      },
      user: () => {
        return Store.state.user
      },
      leftMenuVisible: function () {
        return Store.state.leftMenuVisible
      },
      isShowMXPreloader () {
        return Store.state.isShowMXPreloader
      }
    },
    components: {
      'app-header': Header,
      'app-top': TopSection,
      'app-share-tickets': SharePopup,
      'app-view-qr': QrPopup,
      'app-view-qr-card': QrCardPopup,
      'app-support': SupportPopup,
      'app-change-name': ChangeName,
      'app-left-menu': LeftMenu,
      'app-mob-menu': MobMenu,
      'next-lvl-requirements': NextLvlRequirements,
      'next-lvl-achieved': NextLvlAchieved,
      'fill-profile': FillProfile,
      'badge-dets': BadgeDets,
      'points-received': PointsReceived,
      'test-mark': TestMark,
      'mx-preloader': MXPreloader
    },
    created: function () {
      Store.dispatch('getDicts', () => {
        Store.dispatch('getUser', () => {
          // Store.dispatch('getFriendsLevels')
        })
      })
      // Store.dispatch('getCurrentOrders')
      // Store.commit('setWinDimensions', window.innerWidth, window.innerHeight)
      window.addEventListener('resize', function () {
        Store.commit('setWinW', window.innerWidth)
        Store.commit('setWinH', window.innerHeight)
      })
      Store.commit('setWinW', window.innerWidth)
      Store.commit('setWinH', window.innerHeight)
      window.addEventListener('scroll', function () {
        Store.commit('setWinScrollTop', window.scrollY)
      })
    }
  }
</script>

<style src="./sass/index.sass" lang="sass"></style>



// WEBPACK FOOTER //
// App.vue?2ad2959c